module.exports = __webpack_public_path__ + "img/switzerland-cardiovascular-diseases-female.01fd2aa9.png";